<div class="dialog-container">
    <h1 class="condensed dialog-title">{{dialogTitle()}}</h1>
    <div class="dialog-content">
        @if (extraCosts()?.length === 0) {
            <div class="row">
                <div class="col-12">
                    Er zijn nog geen extra kosten aangemaakt. Je kunt deze toevoegen via het prijzenscherm.
                </div>
            </div>
        } @else {
            <div class="row">
                <mat-form-field class="col-6" appearance="fill">
                    <mat-label>Soort kosten</mat-label>
                    <mat-select
                            (ngModelChange)="costTypeChanged($event)"
                            [(ngModel)]="extraCostTypeId"
                            placeholder="Soort kosten">
                        @for (cost of extraCosts(); track cost) {
                            <mat-option [value]="cost.id">
                                {{cost.name}}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="col-6 txtblack" appearance="fill">
                    <mat-label>Prijs per {{extraCostTypeUnit()}}</mat-label>
                    <span matPrefix>€&nbsp;&nbsp;</span>
                    <input disabled matInput type="text" value="{{extraCostsPricesMap[extraCostTypeId] | number:'1.2-2'}}">
                </mat-form-field>
            </div>
            <div class="row">
                <mat-form-field class="col-6" appearance="fill">
                    <mat-label>Aantal</mat-label>
                    <input
                            [(ngModel)]="number"
                            [disabled]="extraCostType?.count_based_on !== ExtraCostCountType.count"
                            [min]="0.1"
                            matInput
                            step="0.1"
                            type="number">
                    @if (extraCostType) {
                        <span matSuffix>{{extraCostType.unit}}</span>
                    }
                </mat-form-field>
                <mat-form-field class="col-6 txtblack" appearance="fill">
                    <mat-label>Totaal prijs</mat-label>
                    <span matPrefix>€&nbsp;&nbsp;</span>
                    <input disabled matInput type="text" value="{{number * extraCostsPricesMap[extraCostTypeId] | number:'1.2-2'}}">
                </mat-form-field>
            </div>
            <mat-form-field class="w-100" appearance="fill">
                <mat-label>Opmerking</mat-label>
                <input [(ngModel)]="comment" matInput placeholder="Opmerking" type="text">
            </mat-form-field>
        }
    </div>
    <div class="d-flex flex-wrap">
        <button mat-button (click)="close()">Annuleren</button>
        @if (extraCosts()?.length !== 0) {
            <div class="spacer"></div>
            @if (hasId()) {
                <button (click)="delete()" class="me-3" color="primary" mat-icon-button>
                    <i class="fas fa-trash"></i>
                </button>
            }
            <button (click)="save()" cdkFocusInitial color="primary" mat-raised-button>
                {{buttonLabel()}}
            </button>
        }
    </div>
</div>
